import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/card',
  component: LAYOUT,
  name: 'Card',
  redirect: '/card/detail',
  meta: {
    title: '卡券详情',
  },
  children: [
    {
      path: 'detail',
      name: 'CardDetail',
      meta: {
        title: '卡券详情',
      },
      component: () => import('@/views/card/detail'),
    },
  ],
};
